import React from 'react';
import CountdownTimer from './CountdownTimer';

const Hero = () => {
  return (
    <section className="min-h-screen flex items-center bg-black pt-28 pb-12">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 w-full">
        {/* Top Grid - Heading and Image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-12">
          {/* Left Content */}
          <div className="text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-outfit font-800 text-white mb-6 leading-tight">
              AI Day — Exploring Intelligence. Empowering Innovation.
            </h1>
            
            <p className="text-lg md:text-xl font-outfit font-600 text-gray-300 mb-8 leading-relaxed">
              A flagship initiative by <a href="https://aianytime.net/" target="_blank" rel="noopener noreferrer" className="text-crimson font-800 hover:underline">AI Anytime</a>, bringing AI projects, 
              industry conversations, and hands-on learning to universities, startups, and communities — every quarter.
            </p>

            {/* Stats Badges */}
            <div className="flex flex-wrap gap-3">
              <div className="bg-white rounded-full px-5 py-2 flex items-center gap-2">
                <svg className="w-5 h-5 text-crimson" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                <span className="text-black font-outfit font-800 text-sm">45,000+ Subscribers</span>
              </div>
              <div className="bg-white rounded-full px-5 py-2 flex items-center gap-2">
                <svg className="w-5 h-5 text-crimson" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
                <span className="text-black font-outfit font-800 text-sm">10,000+ Community</span>
              </div>
              <div className="bg-white rounded-full px-5 py-2 flex items-center gap-2">
                <svg className="w-5 h-5 text-crimson" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z"/>
                </svg>
                <span className="text-black font-outfit font-800 text-sm">50+ Events</span>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="space-y-6">
            {/* Event Image */}
            <div className="relative rounded-lg overflow-hidden shadow-2xl border-4 border-gray-800 hover:border-crimson transition-all duration-300">
              <img 
                src="/images/backgrounds/hero section.png" 
                alt="AI Day Event" 
                className="w-full h-auto object-cover"
              />
            </div>

            {/* Quote Box */}
            <div className="bg-gray-900 border-l-4 border-crimson p-6 rounded">
              <p className="text-white font-outfit font-600 italic mb-2">
                "AI will not replace you. A person using AI will."
              </p>
              <p className="text-gray-400 font-outfit font-600 text-sm">
                The question is: <span className="text-white font-800">which side will you be on?</span>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Section - Countdown and CTA */}
        <div className="text-center max-w-4xl mx-auto">
          <p className="text-white font-outfit font-600 mb-4 text-lg">
            Next AI Day @ GITAM University: <span className="text-crimson font-800">Thu–Fri, March 5–6, 2026 - 10:00 AM IST</span>
          </p>
          
          <div className="mb-8 flex justify-center">
            <CountdownTimer targetDate="2026-03-05T10:00:00+05:30" />
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#events" 
              className="btn-primary w-full sm:w-auto text-center"
            >
              View Upcoming Events
            </a>
            <a 
              href="#host" 
              className="btn-secondary-light w-full sm:w-auto text-center"
            >
              Partner With Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
